module.exports = __webpack_public_path__ + "img/HiwaQader-KulanayPshila.2bf69de4.jpg";